
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/[name]",
      function () {
        return require("private-next-pages/guides/[name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/[name]"])
      });
    }
  